import { GameSettings } from './GameSettings';

export type VirtualAction =
  | 'up'
  | 'down'
  | 'left'
  | 'right'
  | 'interact'
  | 'confirm'
  | 'cancel';

const heldState: Record<VirtualAction, boolean> = {
  up: false,
  down: false,
  left: false,
  right: false,
  interact: false,
  confirm: false,
  cancel: false,
};

const justDownState: Record<VirtualAction, boolean> = {
  up: false,
  down: false,
  left: false,
  right: false,
  interact: false,
  confirm: false,
  cancel: false,
};

export function isTouchControlsPreferred() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  return navigator.maxTouchPoints > 0 || window.matchMedia?.('(pointer: coarse)').matches === true;
}

export function setVirtualHeld(action: VirtualAction, isHeld: boolean) {
  if (isHeld && !heldState[action]) justDownState[action] = true;
  heldState[action] = isHeld;
}

export function pulseVirtualAction(action: VirtualAction) {
  justDownState[action] = true;
  triggerVirtualHaptic();
}

export function pulseVirtualActions(actions: VirtualAction[]) {
  actions.forEach((action) => {
    justDownState[action] = true;
  });
  triggerVirtualHaptic();
}

export function isVirtualDown(actions: VirtualAction[]) {
  return actions.some((action) => heldState[action]);
}

export function isVirtualJustDown(actions: VirtualAction[]) {
  const triggered = actions.some((action) => justDownState[action]);
  if (triggered) actions.forEach((action) => {
    justDownState[action] = false;
  });
  return triggered;
}

export function resetVirtualControls() {
  (Object.keys(heldState) as VirtualAction[]).forEach((action) => {
    heldState[action] = false;
    justDownState[action] = false;
  });
}

export function releaseVirtualDirections() {
  (['up', 'down', 'left', 'right'] as VirtualAction[]).forEach((action) => {
    heldState[action] = false;
    justDownState[action] = false;
  });
}

export function triggerVirtualHaptic(duration = 12) {
  if (!GameSettings.get('hapticFeedback') || typeof navigator === 'undefined') return;
  try {
    navigator.vibrate?.(duration);
  } catch {}
}
